<app-loading *ngIf="cargando"></app-loading>
<section class="politicas-talanquera" *ngIf="!cargando">
  <div class="politicas-talanquera-encabezado">
    <h3>{{ 'TALANQUERA.LBL_POLITICASDETENER' | translate }}</h3>
  </div>
  <div class="grid">
    <!-- ESTADOS -->
    <div class="col-12 lg:col-4 xl:col-3">
      <div class="flex align-items-end gap-4 contenedor-formulario" *ngIf="!guardandoEstadoDetener">
        <div class="div-form">
          <label for="estado">* {{ "TALANQUERA.LBL_ESTADOSAPLICADAS" | translate }}</label>
          <div>
            <p-dropdown
              id="estado"
              [options]="listaEstados"
              [(ngModel)]="estadoDetener"
              placeholder="{{ 'LBL_SELECCIONE' | translate }}"
              emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
              emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
              optionValue="value"
              optionLabel="label"
              [disabled]="!habilitarEdicionEstado || esDetalle"
            ></p-dropdown>
            <div
              class="p-message p-messages-error p-corner-all"
              *ngIf="submittedEstadoDetener && estadoDetener"
            >
              <i class="fa fa-close"></i
              >{{ "TALANQUERA.LBL_ESTADOS" | translate }}
              {{ "LBL_REQUERIDO" | translate }}
            </div>
          </div>
        </div>
        <button *ngIf="habilitarEdicionEstado && !esDetalle"
                icon="fa fa-floppy-o"
                type="submit"
                pButton
                (click)="guardarEstadoPoliticaDetener()"
        ></button>
        <button *ngIf="!habilitarEdicionEstado && !esDetalle"
                icon="fa fa-pencil"
                type="submit"
                pButton
                (click)="habilitarEstadoPoliticaDetener()"
        ></button>
      </div>
      <div *ngIf="guardandoEstadoDetener">
        <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
        <span>{{'LBL_GUARDANDO' | translate }}</span>
      </div>
    </div>
    <div class="col-12 lg:col-8 xl:col-9">
      <div class="contenedor-formulario--border">
        <form [formGroup]="formularioDetener" *ngIf="!esDetalle">
          <div class="grid">
            <!-- REGLA -->
            <div class="col-12 md:col-3">
              <div class="div-form">
                <label for="regla2">* {{ "TALANQUERA.LBL_REGLA" | translate }}</label>
                <div>
                  <p-dropdown
                    id="regla2"
                    [options]="listasReglasTalanquera"
                    formControlName="regla"
                    placeholder="{{ 'LBL_SELECCIONE' | translate }}"
                    emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                    emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                    optionValue="value"
                    optionLabel="label"
                    (onChange)="filtrarVinculacionesNoConfiguradas()"
                  ></p-dropdown>
                  <div
                    class="p-message p-messages-error p-corner-all"
                    *ngIf="submitted && fDetener.regla.invalid"
                  >
                    <i class="fa fa-close"></i
                    >{{ "TALANQUERA.LBL_REGLA" | translate }}
                    {{ "LBL_REQUERIDO" | translate }}
                  </div>
                </div>
              </div>
            </div>
            <!-- VINCULACION -->
            <div class="col-12 md:col-3">
              <div class="div-form">
                <label for="vinculacion2">* {{ "TALANQUERA.LBL_VINCULACION" | translate }}</label>
                <div>
                  <p-multiSelect id="vinculacion2" name="vinculacion" [options]="listasTiposVinculacionesDetener" filter="filter"
                                 defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                                 selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}" formControlName="vinculacion"
                                 emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                 emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                 optionValue="value"
                                 optionLabel="label"
                  ></p-multiSelect>
                  <div
                    class="p-message p-messages-error p-corner-all"
                    *ngIf="submitted && fDetener.vinculacion.invalid"
                  >
                    <i class="fa fa-close"></i
                    >{{ "TALANQUERA.LBL_VINCULACION" | translate }}
                    {{ "LBL_REQUERIDO" | translate }}
                  </div>
                </div>
              </div>
            </div>
            <!-- CAUSAL -->
            <div class="col-12 md:col-3">
              <div class="div-form">
                <label for="causal">* {{ "TALANQUERA.LBL_CAUSAL" | translate }}</label>
                <div>
                  <p-dropdown
                    id="causal"
                    [options]="lIstasCausalesSolicitudes"
                    formControlName="causal"
                    placeholder="{{ 'LBL_SELECCIONE' | translate }}"
                    emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                    emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                    optionValue="value"
                    optionLabel="label"
                  ></p-dropdown>
                  <div
                    class="p-message p-messages-error p-corner-all"
                    *ngIf="submitted && fDetener.causal.invalid"
                  >
                    <i class="fa fa-close"></i
                    >{{ "TALANQUERA.LBL_CAUSAL" | translate }}
                    {{ "LBL_REQUERIDO" | translate }}
                  </div>
                </div>
              </div>
            </div>
            <!-- OPCIONES-->
            <div class="col-12 md:col-3">
              <div *ngIf="!guardando" class="h-full flex align-items-end gap-2">
                <button label="{{'BTN_CANCELAR' | translate }}"
                        type="button" pButton (click)="limpiarFormulario()"></button>
                <button icon="fa fa-plus" label="{{'BTN_AGREGAR' | translate }}"
                        type="submit"
                        pButton (click)="agregarDetener()" *ngIf="!itemSeleccionado"></button>
                <button icon="fa fa-pencil" label="{{'BTN_EDITAR' | translate }}"
                        type="submit"
                        pButton (click)="editarDetener()" *ngIf="itemSeleccionado"></button>
              </div>
              <div *ngIf="guardando">
                <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                <span>{{'LBL_GUARDANDO' | translate }}</span>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="grid">
    <div class="col-12">
      <p-table
        *ngIf="!guardando"
        [columns]="columnasDetener"
        [value]="registrosDetener"
        [paginator]="true"
        [rows]="10"
        paginatorPosition="bottom">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td class="text-center">{{row.vinculacion ? row.vinculacion : " - "}}</td>
            <td class="text-center">{{row.regla ? row.regla : " - "}}</td>
            <!-- <td class="text-center">{{row.estado ? row.estado : " - "}}</td> -->
            <td class="text-center">{{row.causal ? row.causal : " - "}}</td>
            <td *ngIf="!esDetalle" class="text-center">
              <div class="btn-group" role="group">
                <button
                  type="button"
                  class="p-button p-button-success btn"
                  icon="fa fa-trash" data-toggle="tooltip"
                  title="{{'BTN_INHABILITAR' | translate}}"
                  pButton
                  (click)="inhabilitarPoliticaDetener(row)"
                ></button>
                <button
                  type="button"
                  class="p-button p-button-success btn"
                  icon="fa fa-pencil"
                  data-toggle="tooltip"
                  title="{{ 'BTN_EDITAR' | translate }}"
                  pButton
                  (click)="editarPoliticaDetener(row)"
                ></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</section>
<section class="politicas-talanquera" *ngIf="!cargando">
  <div class="politicas-talanquera-encabezado">
    <h3>{{ 'TALANQUERA.LBL_POLITICASEXCEPCION' | translate }}</h3>
  </div>
  <form [formGroup]="formulario" *ngIf="!esDetalle">
    <div class="grid">
      <!-- REGLA -->
      <div class="col-12 md:col-3">
        <div class="div-form">
          <label for="regla">* {{ "TALANQUERA.LBL_REGLA" | translate }}</label>
          <div>
            <p-dropdown
              id="regla"
              [options]="listasReglasTalanquera"
              formControlName="regla"
              placeholder="{{ 'LBL_SELECCIONE' | translate }}"
              emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
              emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
              optionValue="value"
              optionLabel="label"
              (onChange)="filtrarVinculacionesExcepcionNoConfiguradas()"
            ></p-dropdown>
            <div
              class="p-message p-messages-error p-corner-all"
              *ngIf="submittedExcepcion && f.regla.invalid"
            >
              <i class="fa fa-close"></i
              >{{ "TALANQUERA.LBL_REGLA" | translate }}
              {{ "LBL_REQUERIDO" | translate }}
            </div>
          </div>
        </div>
      </div>
      <!-- VINCULACION -->
      <div class="col-12 md:col-3">
        <div class="div-form">
          <label for="vinculacion">* {{ "TALANQUERA.LBL_VINCULACION" | translate }}</label>
          <div>
<!--            <p-dropdown-->
<!--              id="vinculacion"-->
<!--              [options]="listasTiposVinculaciones"-->
<!--              formControlName="vinculacion"-->
<!--              placeholder="{{ 'LBL_SELECCIONE' | translate }}"-->
<!--              emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"-->
<!--              emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"-->
<!--              optionValue="value"-->
<!--              optionLabel="label"-->
<!--            ></p-dropdown>-->
            <p-multiSelect id="vinculacion" name="vinculacion" [options]="listasTiposVinculacionesExcepcion" filter="filter"
                           defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                           selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}" formControlName="vinculacion"
                           emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                           emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                           optionValue="value"
                           optionLabel="label"
            ></p-multiSelect>
            <div
              class="p-message p-messages-error p-corner-all"
              *ngIf="submittedExcepcion && f.vinculacion.invalid"
            >
              <i class="fa fa-close"></i
              >{{ "TALANQUERA.LBL_VINCULACION" | translate }}
              {{ "LBL_REQUERIDO" | translate }}
            </div>
          </div>
        </div>
      </div>
      <!-- MANEJA ADJUNTO -->
      <div class="col-12 md:col-3">
        <div class="flex align-items-center justify-content-center h-full">
          <p-checkbox
            label="{{ 'TALANQUERA.LBL_MANEJAADJUNTO' | translate}}"
            binary="false"
            id="manejaAdjunto"
            name="manejaAdjunto"
            formControlName="manejaAdjunto"
            (onChange)="validarAdjunto()"
          ></p-checkbox>
        </div>
      </div>
      <!-- ADJUNTO -->
      <div class="col-12 md:col-3" *ngIf="indicadoManejaAdjunto">
        <div class="div-form">
          <label for="adjunto">* {{ "TALANQUERA.LBL_ADJUNTO" | translate }}</label>
          <div>
            <p-dropdown
              id="adjunto"
              [options]="listasRespaldos"
              formControlName="adjunto"
              placeholder="{{ 'LBL_SELECCIONE' | translate }}"
              emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
              emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
              optionValue="value"
              optionLabel="label"
            ></p-dropdown>
            <div
              class="p-message p-messages-error p-corner-all"
              *ngIf="submittedExcepcion && f.adjunto.invalid"
            >
              <i class="fa fa-close"></i
              >{{ "TALANQUERA.LBL_ADJUNTO" | translate }}
              {{ "LBL_REQUERIDO" | translate }}
            </div>
          </div>
        </div>
      </div>
      <!-- NIVELES -->
      <div class="col-12 md:col-3">
        <div class="div-form">
          <label for="nivel">* {{ "TALANQUERA.LBL_NIVEL" | translate }}</label>
          <div>
            <p-dropdown
              id="nivel"
              [options]="listaNiveles"
              formControlName="nivel"
              placeholder="{{ 'LBL_SELECCIONE' | translate }}"
              emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
              emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
              optionValue="value"
              optionLabel="label"
            ></p-dropdown>
            <div
              class="p-message p-messages-error p-corner-all"
              *ngIf="submittedExcepcion && f.nivel.invalid"
            >
              <i class="fa fa-close"></i
              >{{ "TALANQUERA.LBL_NIVEL" | translate }}
              {{ "LBL_REQUERIDO" | translate }}
            </div>
          </div>
        </div>
      </div>
      <!-- EXCEPCION -->
      <div class="col-12 md:col-6">
        <div class="div-form">
          <label for="definicioExcepcion">* {{ "TALANQUERA.LBL_EXCEPCION" | translate }}</label >
          <div>
            <input
              type="text"
              pInputText
              id="definicioExcepcion"
              name="definicioExcepcion"
              autocomplete="off"
              formControlName="definicioExcepcion"
              maxlength="250"
            />
            <div
              class="p-message p-messages-error p-corner-all"
              *ngIf="submittedExcepcion && f.definicioExcepcion.invalid"
            >
              <i class="fa fa-close"></i
              >{{ "TALANQUERA.LBL_EXCEPCION" | translate }}
              {{ "LBL_REQUERIDO" | translate }}
            </div>
          </div>
        </div>
      </div>
      <!-- ROLES -->
      <div class="col-12 md:col-3">
        <div class="div-form">
          <label for="rol">{{ "TALANQUERA.LBL_ROL" | translate }}</label>
          <div>
<!--            <p-dropdown-->
<!--              id="rol"-->
<!--              [options]="listaRoles"-->
<!--              formControlName="rol"-->
<!--              placeholder="{{ 'LBL_SELECCIONE' | translate }}"-->
<!--              emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"-->
<!--              emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"-->
<!--              optionValue="value"-->
<!--              optionLabel="label"-->
<!--            ></p-dropdown>-->
            <p-multiSelect id="rol" name="rol" [options]="listaRoles" filter="filter"
                           defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                           selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}" formControlName="rol"
                           emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                           emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                           optionValue="value"
                           optionLabel="label"
            ></p-multiSelect>
            <div
              class="p-message p-messages-error p-corner-all"
              *ngIf="submittedExcepcion  && f.rol.invalid"
            >
              <i class="fa fa-close"></i
              >{{ "TALANQUERA.LBL_ROL" | translate }}
              {{ "LBL_REQUERIDO" | translate }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="!guardandoExcepcion" class="flex align-items-center justify-content-center my-4 gap-2">
      <button label="{{'BTN_CANCELAR' | translate }}"
              type="button" pButton (click)="limpiar()"></button>
      <button icon="fa fa-plus" label="{{'BTN_AGREGAR' | translate }}"
              type="submit"
              pButton (click)="agregar()" *ngIf="!item"></button>
      <button icon="fa fa-pencil" label="{{'BTN_EDITAR' | translate }}"
              type="submit"
              pButton (click)="editarExcepcion()" *ngIf="item"></button>
    </div>
    <div *ngIf="guardandoExcepcion">
      <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
      <span>{{'LBL_GUARDANDO' | translate }}</span>
    </div>
  </form>
  <div class="grid">
    <div class="col-12">
      <p-table
        *ngIf="!guardandoExcepcion"
        [columns]="columnasExcepcion"
        [value]="registrosExcepcion"
        [paginator]="true"
        [rows]="10"
        paginatorPosition="bottom">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td class="text-center">{{row.vinculacion ? row.vinculacion : " - "}}</td>
            <td class="text-center">{{row.regla ? row.regla : " - "}}</td>
            <td class="text-center">
              <p-checkbox
                [(ngModel)]="row.indicadorAdjunto"
                binary="true"
                disabled="true"
              ></p-checkbox>
            </td>
            <td class="text-center">{{row.respaldo ? row.respaldo : " - "}}</td>
            <td class="text-center">{{row.nivel ? row.nivel : " - "}}</td>
            <td class="text-center">
              <span *ngFor="let rol of row.roles">
                {{ rol.rol ? rol.rol : " - " }}
              </span>
            </td>
            <td class="text-center">{{row.definicionExcepcion ? row.definicionExcepcion : " - "}}</td>
            <td *ngIf="!esDetalle" class="text-center">
              <div class="btn-group" role="group">
                <button
                  type="button"
                  class="p-button p-button-success btn"
                  icon="fa fa-trash" data-toggle="tooltip"
                  title="{{'BTN_INHABILITAR' | translate}}"
                  pButton
                  (click)="inhabilitarPoliticaExcepcion(row)"
                ></button>
                <button
                  type="button"
                  class="p-button p-button-success btn"
                  icon="fa fa-pencil"
                  data-toggle="tooltip"
                  title="{{ 'BTN_EDITAR' | translate }}"
                  pButton
                  (click)="editarPoliticaExcepcion(row)"
                ></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</section>

<p-confirmDialog #cd key="inhabilitar">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>

